import axios from 'axios';

const AccountService = {
	me: async () => {
		return await axios.get(`/api/me`);
	},
};

export default AccountService;
